import React, { Component } from 'react'
import SideMenu from '../admin/SideMenu';
import TopMenu from '../admin/TopBar';
import UploadImage from '../utils/UploadImage';
import BasicDropzone from '../utils/Dropzone';
import { base } from '../../base';
import '../../styles/css/AdminMain.css';
import swal from 'sweetalert2';
import RichTextMarkdown from "../utils/RichTextMarkdown";
import ColorPicker from "../utils/ColorPicker";
import {isEmptyHtmlEntity} from "../utils/HelpfulFunction";

class SetUpTeamVariables extends Component {
    constructor(props) {
        super(props);
        this.UploadImage = new UploadImage();
        this.state = {
            tenantVariables: {},
            showTabOneMajor: true,
            showTabTwoMajor: false,
            showTabThreeMajor: false,
            showTabOneMinor: true,
            showTabTwoMinor: false,
            showTabThreeMinor: false,
            loading:true,
            colorsTab: true,
            gameTextTab: 'screens',
            advanced: false
        };
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.handleImageChange = this.handleImageChange.bind(this);
    }

    componentDidMount() {
        this.tenantVariablesRef = base.bindToState(`tenantVariables`, {
            context: this,
            state: 'tenantVariables',
            then(){
                const variables = this.state.tenantVariables || {};
                if(variables.globalPrizeWonHeader || variables.globalPrizeWonBody || variables.globalNoPrizeHeader || variables.globalNoPrizeBody){
                    this.setState({
                        advanced: true
                    })
                }
            }
        });
        this.setState({
            loading: false
        })
    }

    componentWillUnmount() {
      base.removeBinding(this.tenantVariablesRef);
    }

    handleRichTextChange = (name, text) => {
        let tenantVariablesCopy = this.state.tenantVariables;
        if(isEmptyHtmlEntity(text)){
            text = "";
        }
        tenantVariablesCopy[name] = text;
        this.setState({ tenantVariables:  tenantVariablesCopy});
    }

    // Checkboxes that belong to tenantVariables need their own toggler: handleChange puts
    // checkbox values on component state (that's what `advanced` relies on), so they'd never
    // be saved with the rest of the branding.
    toggleTenantVariable = (name) => {
        let tenantVariablesCopy = this.state.tenantVariables;
        tenantVariablesCopy[name] = !tenantVariablesCopy[name];
        this.setState({ tenantVariables:  tenantVariablesCopy});
    }

    handleSubmit(event) {
      event.preventDefault();
      const variables = this.state.tenantVariables;
      const vm = this;
      base.post("tenantVariables/", {
        data: variables,
        then(err){
          vm.setState({loading:false})
          if(!err){
            swal({
                title: 'Tenant Variables Updated!',
                type: 'success',
                toast: true,
                position: 'top-end',
                showConfirmButton: true,
                timer: 10000
              })
          } else {
            swal({
                title: 'There was some error!',
                text: 'Try again and if the problem persists try logging out and logging back in',
                type: 'error',
                confirmButtonText: 'Ok'
              })
            // console.log(err)
          }
        }
      })
    }

    handleChange(event){
        let target = event.target;
        let value = target.value;
        if(target.type === 'checkbox'){
            value = target.checked;
            this.setState({[target.name]: value})
        } else {
            let tenantVariablesCopy = this.state.tenantVariables;
            tenantVariablesCopy[event.target.name] = value
            this.setState({ tenantVariables:  tenantVariablesCopy});
        }
    }

    handleImageChange(event){
      const name_of_file = event.target.name;
      const target = this[name_of_file];
      const file_to_update =target.files[0];
      this.setState({loading:true});
      const vm = this;
      this.UploadImage.upload_file(file_to_update).then(res => {
          vm.setState({loading:false})
          if(res.error) {
              swal({
                  title: 'Image cannot be uploaded',
                  text: res.error,
                  type: 'warning',
                  confirmButtonText: 'Ok'
              })
          } else if(res.imageUrl) {
              const tenantVariablesCopy = vm.state.tenantVariables;
              tenantVariablesCopy[name_of_file] = res.imageUrl;
              vm.setState({
                  tenantVariables: tenantVariablesCopy,
              }, () => {
                  vm[name_of_file].value = ""
              });
          } else {
              swal({
                  title: 'Image cannot be uploaded',
                  text: 'There was some issue with the image upload, please check the image type and size and try again',
                  type: 'warning',
                  confirmButtonText: 'Ok'
              })
          }
      })
    }

    onImageDropped = (name, imageUrl) => {
        const tenantVariablesCopy = this.state.tenantVariables;
        tenantVariablesCopy[name] = imageUrl;
        this.setState({ tenantVariables: tenantVariablesCopy });
    }

    renderImageDropzone(name, title, dims, note) {
        return (
            <div className="form-group" style={{textAlign:'center', margin:20, minWidth: 230}}>
                <label htmlFor={name}>{title}{dims && <><br/>{dims}</>}{note && <><br/><span style={{fontSize:'10px', color:'grey'}}>{note}</span></>}</label>
                <BasicDropzone
                    name={name}
                    accept="image/*"
                    multiple={false}
                    maxSize={2200000}
                    value={this.state.tenantVariables[name] || undefined}
                    uploadFn={(file) => this.UploadImage.upload_file(file)}
                    onUploaded={this.onImageDropped}
                />
            </div>
        );
    }

    toggleColors(){
        if(this.state.colorsTab){
            document.getElementById('showColors').classList.remove('active');
            document.getElementById('showImages').classList.add('active');
        } else {
            document.getElementById('showColors').classList.add('active');
            document.getElementById('showImages').classList.remove('active');
        }
        this.setState({colorsTab: !this.state.colorsTab})
    }

    tripleToggleControl(element, whichToggle){
        const tabOne = "showTabOne" + whichToggle;
        const tabTwo = "showTabTwo" + whichToggle;
        const tabThree = "showTabThree" + whichToggle;
        const firstElement = document.getElementById('showfirst' + whichToggle);
        const secondElement = document.getElementById('showsecond' + whichToggle);
        const thirdElement = document.getElementById('showthird' + whichToggle);
        if(element === "first"){
            firstElement.classList.add('active');
            secondElement.classList.remove('active');
            if(thirdElement){
                thirdElement.classList.remove('active');
            }
            this.setState({
                [tabOne]: true,
                [tabTwo]: false,
                [tabThree]: false,
            })
        }else if(element === "second"){
            firstElement.classList.remove('active');
            secondElement.classList.add('active');
            if(thirdElement){
                thirdElement.classList.remove('active');
            }
            this.setState({
                [tabOne]: false,
                [tabTwo]: true,
                [tabThree]: false,
            })
        } else {
            firstElement.classList.remove('active');
            secondElement.classList.remove('active');
            if(thirdElement){
                thirdElement.classList.add('active');
            }
            this.setState({
                [tabOne]: false,
                [tabTwo]: false,
                [tabThree]: true,
            })
        }
    }

    render() {
        const tenantVariables = this.state.tenantVariables || {};
        return (
          <div className="admin-wrapper">
            <div className="loading-screen" style={{display: this.state.loading ? 'block' : 'none' }}/>
            <SideMenu/>
            <TopMenu/>
            <div className="admin-main-panel">
                <p className="admin-header-text" style={{marginBottom:0, marginTop:'5px'}}>Game Branding</p>
                <p className="admin-subheader-text">This is where you can edit the game branding on your activation</p>
                <div className="container-out">
                  <div className="admin-form-box" style={{marginTop:'0px', paddingTop:'5px'}}>
                    <form onSubmit={this.handleSubmit} id="create-game-form">
                      <button className="btn btn-primary btn-lg update-button" id="submitButton" style={{marginBottom:'20px'}}><span className="fa fa-arrow-circle-o-up"/> Update</button>
                      <ul className="nav nav-tabs nav-justified nav-bordered mb-3">
                          <li className="nav-item" onClick={()=> this.tripleToggleControl('first', 'Major')}>
                              <a href="#" aria-expanded="false" className="nav-link active" id="showfirstMajor">
                                  <i className="mdi mdi-home-variant d-lg-none d-block mr-1"/>
                                  <span className="d-none d-lg-block">Fan Color/Images</span>
                              </a>
                          </li>
                          <li className="nav-item" onClick={()=> this.tripleToggleControl('second', 'Major')}>
                              <a href="#" aria-expanded="true" className="nav-link" id="showsecondMajor">
                                  <i className="mdi mdi-home-variant d-lg-none d-block mr-1"/>
                                  <span className="d-none d-lg-block">Scoreboard Color/Images</span>
                              </a>
                          </li>
                          <li className="nav-item" onClick={()=> this.tripleToggleControl('third', 'Major')}>
                              <a href="#" aria-expanded="true" className="nav-link" id="showthirdMajor">
                                  <i className="mdi mdi-account-circle d-lg-none d-block mr-1"/>
                                  <span className="d-none d-lg-block">Game Text</span>
                              </a>
                          </li>
                      </ul>
                        <ul className="nav nav-tabs nav-justified nav-bordered mb-3" style={{display: this.state.showTabOneMajor === true ? '' : 'none'}}>
                            <li className="nav-item" onClick={()=> this.toggleColors()}>
                                <a href="#" aria-expanded="false" className="nav-link active" id="showColors">
                                    <i className="mdi mdi-home-variant d-lg-none d-block mr-1"/>
                                    <span className="d-none d-lg-block">Colors</span>
                                </a>
                            </li>
                            <li className="nav-item" onClick={()=> this.toggleColors()}>
                                <a href="#" aria-expanded="true" className="nav-link" id="showImages">
                                    <i className="mdi mdi-home-variant d-lg-none d-block mr-1"/>
                                    <span className="d-none d-lg-block">Images</span>
                                </a>
                            </li>
                        </ul>
                        <ul className="nav nav-tabs nav-justified nav-bordered mb-3" style={{display: this.state.showTabTwoMajor === true ? '' : 'none'}}>
                            <li className="nav-item" onClick={()=> this.tripleToggleControl("first", "Minor")}>
                                <a href="#" aria-expanded="false" className="nav-link active" id="showfirstMinor">
                                    <i className="mdi mdi-home-variant d-lg-none d-block mr-1"/>
                                    <span className="d-none d-lg-block">Colors</span>
                                </a>
                            </li>
                            <li className="nav-item" onClick={()=> this.tripleToggleControl("second", "Minor")}>
                                <a href="#" aria-expanded="true" className="nav-link" id="showsecondMinor">
                                    <i className="mdi mdi-home-variant d-lg-none d-block mr-1"/>
                                    <span className="d-none d-lg-block">Images</span>
                                </a>
                            </li>
                            <li className="nav-item" onClick={()=> this.tripleToggleControl("third", "Minor")}>
                                <a href="#" aria-expanded="true" className="nav-link" id="showthirdMinor">
                                    <i className="mdi mdi-home-variant d-lg-none d-block mr-1"/>
                                    <span className="d-none d-lg-block">Timing/Blur</span>
                                </a>
                            </li>
                        </ul>
                        <ul className="nav nav-tabs nav-justified nav-bordered mb-3" style={{display: this.state.showTabThreeMajor === true ? '' : 'none'}}>
                            <li className="nav-item" onClick={()=> this.setState({gameTextTab: 'screens'})}>
                                <a href="#" aria-expanded="false" className={"nav-link" + (this.state.gameTextTab === 'screens' ? " active" : "")}>
                                    <i className="mdi mdi-home-variant d-lg-none d-block mr-1"/>
                                    <span className="d-none d-lg-block">Main Screens</span>
                                </a>
                            </li>
                            <li className="nav-item" onClick={()=> this.setState({gameTextTab: 'gameplay'})}>
                                <a href="#" aria-expanded="false" className={"nav-link" + (this.state.gameTextTab === 'gameplay' ? " active" : "")}>
                                    <i className="mdi mdi-home-variant d-lg-none d-block mr-1"/>
                                    <span className="d-none d-lg-block">Gameplay & Popups</span>
                                </a>
                            </li>
                            <li className="nav-item" onClick={()=> this.setState({gameTextTab: 'results'})}>
                                <a href="#" aria-expanded="false" className={"nav-link" + (this.state.gameTextTab === 'results' ? " active" : "")}>
                                    <i className="mdi mdi-home-variant d-lg-none d-block mr-1"/>
                                    <span className="d-none d-lg-block">Results & Prizes</span>
                                </a>
                            </li>
                            <li className="nav-item" onClick={()=> this.setState({gameTextTab: 'login'})}>
                                <a href="#" aria-expanded="false" className={"nav-link" + (this.state.gameTextTab === 'login' ? " active" : "")}>
                                    <i className="mdi mdi-home-variant d-lg-none d-block mr-1"/>
                                    <span className="d-none d-lg-block">Login Form</span>
                                </a>
                            </li>
                        </ul>
                      <div style={{display: this.state.showTabOneMajor ? 'block' : 'none'}}>
                          <div style={{display: this.state.colorsTab ? 'block': 'none'}}>
                              <div className="row">
                                  <div className="col-md-6">
                                      <h4>Button Colors</h4>
                                      <div className="form-inline">
                                          <div style={{display: "flex", alignItems: "center"}}>
                                              <ColorPicker
                                                  name="primaryColor"
                                                  label="Button Color"
                                                  value={this.state.tenantVariables.primaryColor}
                                                  onChange={hex =>
                                                      this.handleChange({
                                                          target: { name: 'primaryColor', value: hex }
                                                      })
                                                  }
                                              />
                                          </div>

                                          <div style={{height:'10px', width:'100%'}}/>

                                          <div style={{display: "flex", alignItems: "center"}}>
                                              <ColorPicker
                                                  name="secondaryColor"
                                                  label="Button Text Color"
                                                  value={this.state.tenantVariables.secondaryColor}
                                                  onChange={hex =>
                                                      this.handleChange({
                                                          target: { name: 'secondaryColor', value: hex }
                                                      })
                                                  }
                                              />
                                          </div>
                                      </div>
                                  </div>
                                  <div className="col-md-6">
                                      <h4>Logout Color</h4>
                                      <div className="form-inline">
                                          <div style={{display: "flex", alignItems: "center"}}>
                                              <ColorPicker
                                                  name="logOutButtonColor"
                                                  label="Button Color"
                                                  value={this.state.tenantVariables.logOutButtonColor}
                                                  onChange={hex =>
                                                      this.handleChange({
                                                          target: { name: 'logOutButtonColor', value: hex }
                                                      })
                                                  }
                                              />
                                          </div>
                                      </div>
                                  </div>
                              </div>
                              <div style={{height:'10px', width:'100%'}}/>
                              <div className="row">
                                  <div className="col-md-6">
                                      <h4>Game Colors</h4>
                                      <div className="form-inline">
                                          <div style={{display: "flex", alignItems: "center"}}>
                                              <ColorPicker
                                                  name="textColor"
                                                  label="Text Color"
                                                  value={this.state.tenantVariables.textColor}
                                                  onChange={hex =>
                                                      this.handleChange({
                                                          target: { name: 'textColor', value: hex }
                                                      })
                                                  }
                                              />
                                          </div>
                                          <div style={{height:'10px', width:'100%'}}/>

                                          <div style={{display: "flex", alignItems: "center"}}>
                                              <ColorPicker
                                                  name="highlightPickColor"
                                                  label="Highlight Pick Color"
                                                  value={this.state.tenantVariables.highlightPickColor}
                                                  onChange={hex =>
                                                      this.handleChange({
                                                          target: { name: 'highlightPickColor', value: hex }
                                                      })
                                                  }
                                              />
                                          </div>
                                          <div style={{height:'10px', width:'100%'}}/>

                                          <div style={{display: "flex", alignItems: "center"}}>
                                              <ColorPicker
                                                  name="resultsTextColor"
                                                  label="Results Screen Text Color"
                                                  value={this.state.tenantVariables.resultsTextColor}
                                                  onChange={hex =>
                                                      this.handleChange({
                                                          target: { name: 'resultsTextColor', value: hex }
                                                      })
                                                  }
                                              />
                                          </div>
                                          <span style={{fontSize:'10px', color:'grey'}}>Color of the "how many you got right" screen at game end. Defaults to Text Color.</span>
                                      </div>
                                  </div>
                                  <div className="col-md-6">
                                      <h4>Other Colors</h4>
                                      <div className="form-inline">
                                          <div style={{display: "flex", alignItems: "center"}}>
                                              <ColorPicker
                                                  name="hintColor"
                                                  label="Hint Color"
                                                  value={this.state.tenantVariables.hintColor}
                                                  onChange={hex =>
                                                      this.handleChange({
                                                          target: { name: 'hintColor', value: hex }
                                                      })
                                                  }
                                              />
                                          </div>
                                          <div style={{height:'10px', width:'100%'}}/>
                                          <div style={{display: "flex", alignItems: "center"}}>
                                              <ColorPicker
                                                  name="glowColor"
                                                  label="Glow / Accent Color"
                                                  value={this.state.tenantVariables.glowColor}
                                                  onChange={hex =>
                                                      this.handleChange({
                                                          target: { name: 'glowColor', value: hex }
                                                      })
                                                  }
                                              />
                                          </div>
                                          <div style={{height:'10px', width:'100%'}}/>
                                          <div style={{display: "flex", alignItems: "center"}}>
                                              <ColorPicker
                                                  name="progressBarColor"
                                                  label="Progress Bar Color"
                                                  value={this.state.tenantVariables.progressBarColor}
                                                  onChange={hex =>
                                                      this.handleChange({
                                                          target: { name: 'progressBarColor', value: hex }
                                                      })
                                                  }
                                              />
                                          </div>
                                      </div>
                                  </div>
                              </div>
                          </div>
                            <div style={{display: this.state.colorsTab ? 'none': 'block'}}>
                                <div className="row">
                                    <div className="col-md-12">
                                        <div className="admin-grid-container three-columns" style={{display: "flex", alignItems: 'flex-end', justifyContent: 'space-evenly', flexWrap: 'wrap'}}>
                                          {this.renderImageDropzone('backgroundImage', 'Phone Background Image', '(750px X 1334px)', '')}
                                          {this.renderImageDropzone('frontLogoImage', 'Front Logo', '(700px X 700px)', '')}
                                          {this.renderImageDropzone('topLeftImage', 'Top Logo', '(200px X 200px)', '')}
                                          {tenantVariables.collectUsername && this.renderImageDropzone('usernameLogoImage', 'Username Page Logo', '', 'Defaults to the Front Logo')}
                                          {tenantVariables.collectUsername && this.renderImageDropzone('usernameBackgroundImage', 'Username Page Background', '', 'Defaults to the Phone Background')}
                                        </div>
                                    </div>
                                </div>
                            </div>
                      </div>

                      <div style={{display: this.state.showTabTwoMajor ? 'block' : 'none'}}>
                          <div style={{display: this.state.showTabOneMinor ? 'block': 'none'}}>
                              <h4>Scoreboard Colors</h4>
                              <div className="form-inline">
                                  <div style={{display: "flex", alignItems: "center"}}>
                                      <ColorPicker
                                          name="scoreboardHintColor"
                                          label="Scoreboard Hint Color"
                                          value={this.state.tenantVariables.scoreboardHintColor}
                                          onChange={hex =>
                                              this.handleChange({
                                                  target: { name: 'scoreboardHintColor', value: hex }
                                              })
                                          }
                                      />
                                  </div>
                                  <div style={{height:'10px', width:'100%'}}/>
                              </div>
                              <h4>Leaderboard Colors</h4>
                              <div className="form-inline">
                                  <div style={{display: "flex", alignItems: "center"}}>
                                      <ColorPicker
                                          name="scoreboardFontColor"
                                          label="Header Text Color"
                                          value={this.state.tenantVariables.scoreboardFontColor}
                                          onChange={hex =>
                                              this.handleChange({
                                                  target: { name: 'scoreboardFontColor', value: hex }
                                              })
                                          }
                                      />
                                  </div>
                                  <div style={{height:'10px', width:'100%'}}/>
                                  <div style={{display: "flex", alignItems: "center"}}>
                                      <ColorPicker
                                          name="scoreboardBackgroundFontColor"
                                          label="Header Background Color"
                                          value={this.state.tenantVariables.scoreboardBackgroundFontColor}
                                          onChange={hex =>
                                              this.handleChange({
                                                  target: { name: 'scoreboardBackgroundFontColor', value: hex }
                                              })
                                          }
                                      />
                                  </div>
                                  <div style={{height:'10px', width:'100%'}}/>
                                  <div style={{display: "flex", alignItems: "center"}}>
                                      <ColorPicker
                                          name="scoreboardRankTextColor"
                                          label="Ranking Text Color"
                                          value={this.state.tenantVariables.scoreboardRankTextColor}
                                          onChange={hex =>
                                              this.handleChange({
                                                  target: { name: 'scoreboardRankTextColor', value: hex }
                                              })
                                          }
                                      />
                                  </div>
                                  <div style={{height:'10px', width:'100%'}}/>
                              </div>
                          </div>
                          <div style={{display: this.state.showTabTwoMinor ? 'block' : 'none'}}>
                              <div className="row">
                                  <div className="col-md-12">
                                      <div className="admin-grid-container three-columns" style={{display: "flex", alignItems: 'flex-end', justifyContent: 'space-evenly', flexWrap: 'wrap'}}>
                                          {this.renderImageDropzone('scoreboardBackgroundImage', 'Background Image', '(1920px X 1080px)', '')}
                                          {this.renderImageDropzone('sponsorImage', 'Sponsor Image', '(800px X 800px)', '')}
                                          {this.renderImageDropzone('scoreboardImage', 'Leaderboard Center Image', '(800px X 800px)', '')}
                                          {this.renderImageDropzone('qrCodeScoreboardImage', 'Leaderboard QR Code', '(600px X 600px)', '')}
                                          {this.renderImageDropzone('scoreboardFooterImage', 'Leaderboard Footer Bar', '(1920px X 200px)', '')}
                                      </div>
                                  </div>
                              </div>
                          </div>
                          <div style={{display: this.state.showTabThreeMinor ? 'block' : 'none'}}>
                              <div className="row">
                                  <div className="col-md-6">
                                      <h4>Timing</h4>
                                      <div className="form-inline">
                                          <label htmlFor="timeToDeblur" style={{marginRight: 10}}>Time To Deblur (secs)</label>
                                          <input id="timeToDeblur" name="timeToDeblur" type="number" className="form-control" value={this.state.tenantVariables.timeToDeblur} onChange={this.handleChange} placeholder="30"/>
                                      </div>
                                  </div>
                                  <div className="col-md-6">
                                      <h4>Blur</h4>
                                      <div className="form-inline">
                                          <label htmlFor="startingBlurAmount" style={{marginRight: 10}}>Scoreboard Starting Blur Amount (warning: will not work once the scoreboard has been started)</label>
                                          <input id="startingBlurAmount" name="startingBlurAmount" type="number" className="form-control" value={this.state.tenantVariables.startingBlurAmount} onChange={this.handleChange} placeholder="50"/>
                                      </div>
                                      <div className="form-inline" style={{marginTop: 10}}>
                                          <label htmlFor="fanStartingBlurAmount" style={{marginRight: 10}}>Fan Starting Blur Amount (phone image is smaller, so it usually needs a lower value)</label>
                                          <input id="fanStartingBlurAmount" name="fanStartingBlurAmount" type="number" className="form-control" value={this.state.tenantVariables.fanStartingBlurAmount} onChange={this.handleChange} placeholder="25"/>
                                      </div>
                                      <div className="form-inline" style={{marginTop: 10}}>
                                          <label htmlFor="finalBlurAmount" style={{marginRight: 10}}>Scoreboard Final Blur Amount (the blur it ends at; 0 = fully revealed, blank = default 3, higher = blurrier)</label>
                                          <input id="finalBlurAmount" name="finalBlurAmount" type="number" min="0" className="form-control" value={this.state.tenantVariables.finalBlurAmount} onChange={this.handleChange} placeholder="3"/>
                                      </div>
                                      <div className="form-inline" style={{marginTop: 10}}>
                                          <label htmlFor="fanFinalBlurAmount" style={{marginRight: 10}}>Fan Final Blur Amount (the blur the phone ends at; 0 = fully revealed, blank = default 3, higher = blurrier)</label>
                                          <input id="fanFinalBlurAmount" name="fanFinalBlurAmount" type="number" min="0" className="form-control" value={this.state.tenantVariables.fanFinalBlurAmount} onChange={this.handleChange} placeholder="3"/>
                                      </div>
                                  </div>
                              </div>
                          </div>
                      </div>
                        <div style={{display: this.state.showTabThreeMajor ? 'block' : 'none'}}>
                          <div style={{display: this.state.gameTextTab === 'screens' ? 'block' : 'none'}}>
                            <div className="form-group">
                                <label htmlFor="pageTitle">Page Title:</label>
                                <input id="pageTitle" name="pageTitle" type="text" className="form-control" value={this.state.tenantVariables.pageTitle} onChange={this.handleChange} placeholder="Reveal"/>
                            </div>
                            <div className="form-group">
                                <label htmlFor="playingTextHeader">Header Playing Text:</label>
                                <input id="playingTextHeader" name="playingTextHeader" type="text" className="form-control" value={this.state.tenantVariables.playingTextHeader} onChange={this.handleChange} placeholder="Next game starts during"/>
                                <span style={{fontSize:'10px', color:'grey'}}>Shown on the holding screen above the playing text</span>
                            </div>
                            <div className="form-group">
                                <label htmlFor="playingText">Playing Text:</label>
                                <RichTextMarkdown
                                    field={{
                                        id: "playingText",
                                        name: "playingText",
                                        value: tenantVariables.playingText || ""
                                    }}
                                    form={{
                                        setFieldValue: (field, value) => this.handleRichTextChange('playingText', value)
                                    }}
                                    placeholder="2nd Quarter"
                                />
                            </div>
                            <div className="form-group">
                                <label htmlFor="gameOverHeader">Too Late Header Text:</label>
                                <input id="gameOverHeader" name="gameOverHeader" type="text" className="form-control" value={this.state.tenantVariables.gameOverHeader} onChange={this.handleChange} placeholder="Game Already Ended!"/>
                            </div>
                            <div className="form-group">
                                <label htmlFor="gameOverBody">Too Late Body Text:</label>
                                <RichTextMarkdown
                                    field={{
                                        id: "gameOverBody",
                                        name: "gameOverBody",
                                        value: tenantVariables.gameOverBody || ""
                                    }}
                                    form={{
                                        setFieldValue: (field, value) => this.handleRichTextChange('gameOverBody', value)
                                    }}
                                    placeholder="The game already happened, come back next time to play."
                                />
                            </div>
                          </div>
                          <div style={{display: this.state.gameTextTab === 'gameplay' ? 'block' : 'none'}}>
                            <div className="form-group">
                                <label htmlFor="hintTextLabel">Hint Text Label:</label>
                                <input id="hintTextLabel" name="hintTextLabel" type="text" className="form-control" value={this.state.tenantVariables.hintTextLabel} onChange={this.handleChange} placeholder="HINT"/>
                            </div>
                            <div className="form-group">
                                <label htmlFor="answerPopupCorrectHeader">Correct Answer Popup Header:</label>
                                <input id="answerPopupCorrectHeader" name="answerPopupCorrectHeader" type="text" className="form-control" value={this.state.tenantVariables.answerPopupCorrectHeader} onChange={this.handleChange} placeholder="Correct!"/>
                                <span style={{fontSize:'10px', color:'grey'}}>Header of the popup shown right after a fan picks the right answer</span>
                            </div>
                            <div className="form-group">
                                <label htmlFor="answerPopupCorrectBody">Correct Answer Popup Body:</label>
                                <RichTextMarkdown
                                    field={{
                                        id: "answerPopupCorrectBody",
                                        name: "answerPopupCorrectBody",
                                        value: tenantVariables.answerPopupCorrectBody || ""
                                    }}
                                    form={{
                                        setFieldValue: (field, value) => this.handleRichTextChange('answerPopupCorrectBody', value)
                                    }}
                                    placeholder="You got it right!"
                                />
                            </div>
                            <div className="form-group">
                                <label htmlFor="answerPopupIncorrectHeader">Incorrect Answer Popup Header:</label>
                                <input id="answerPopupIncorrectHeader" name="answerPopupIncorrectHeader" type="text" className="form-control" value={this.state.tenantVariables.answerPopupIncorrectHeader} onChange={this.handleChange} placeholder="Incorrect"/>
                                <span style={{fontSize:'10px', color:'grey'}}>Header of the popup shown right after a fan picks the wrong answer</span>
                            </div>
                            <div className="form-group">
                                <label htmlFor="answerPopupIncorrectBody">Incorrect Answer Popup Body:</label>
                                <RichTextMarkdown
                                    field={{
                                        id: "answerPopupIncorrectBody",
                                        name: "answerPopupIncorrectBody",
                                        value: tenantVariables.answerPopupIncorrectBody || ""
                                    }}
                                    form={{
                                        setFieldValue: (field, value) => this.handleRichTextChange('answerPopupIncorrectBody', value)
                                    }}
                                    placeholder="Better luck on the next one!"
                                />
                            </div>
                            <div className="form-group">
                                <label htmlFor="answerPopupNextButtonText">Answer Popup Button Text:</label>
                                <input id="answerPopupNextButtonText" name="answerPopupNextButtonText" type="text" className="form-control" value={this.state.tenantVariables.answerPopupNextButtonText} onChange={this.handleChange} placeholder="Next Question"/>
                                <span style={{fontSize:'10px', color:'grey'}}>Button that dismisses the correct/incorrect popup and starts the next question (or shows results after the last question)</span>
                            </div>
                          </div>
                          <div style={{display: this.state.gameTextTab === 'results' ? 'block' : 'none'}}>
                            <div className="form-group">
                                <label htmlFor="finalResultsText">Results Screen Header:</label>
                                <input id="finalResultsText" name="finalResultsText" type="text" className="form-control" value={this.state.tenantVariables.finalResultsText} onChange={this.handleChange} placeholder="YOUR RESULTS"/>
                                <span style={{fontSize:'10px', color:'grey'}}>Shown above the score (i.e. 3/5) on the end-of-game results screen</span>
                            </div>
                            <div className="form-group">
                                <label htmlFor="correctLabelText">Results Screen Correct Label:</label>
                                <input id="correctLabelText" name="correctLabelText" type="text" className="form-control" value={this.state.tenantVariables.correctLabelText} onChange={this.handleChange} placeholder="Correct"/>
                                <span style={{fontSize:'10px', color:'grey'}}>Shown below the score (i.e. 3/5) on the end-of-game results screen</span>
                            </div>
                            <div className="form-group">
                                <label htmlFor="belowCorrectText">Below Results Text</label>
                                <RichTextMarkdown
                                    field={{
                                        id: "belowCorrectText",
                                        name: "belowCorrectText",
                                        value: tenantVariables.belowCorrectText || ""
                                    }}
                                    form={{
                                        setFieldValue: (field, value) => this.handleRichTextChange('belowCorrectText', value)
                                    }}
                                    placeholder="Enter text shown under the score on the results screen"
                                />
                            </div>
                            <div className="form-group">
                                <label htmlFor="allowReplay">Allow Play Again</label>
                                <input type="checkbox" checked={!!this.state.tenantVariables.allowReplay} id="allowReplay" name="allowReplay" onChange={() => this.toggleTenantVariable('allowReplay')} style={{marginLeft: 10}}/>
                                <span style={{fontSize:'10px', color:'grey', display:'block'}}>Adds a "Play Again" button to the results screen so fans can replay for fun. Replays are not scored: they never record an answer, award a prize, or reach the leaderboard.</span>
                            </div>
                            {this.state.tenantVariables.allowReplay &&
                                <div className="form-group">
                                    <label htmlFor="replayButtonText">Play Again Button Text:</label>
                                    <input id="replayButtonText" name="replayButtonText" type="text" className="form-control" value={this.state.tenantVariables.replayButtonText || ""} onChange={this.handleChange} placeholder="Play Again"/>
                                    <span style={{fontSize:'10px', color:'grey'}}>Text on the button that restarts the game for fun</span>
                                </div>
                            }
                            <div className="form-group">
                                <label htmlFor="showAdvancedSettings">Advanced</label>
                                <br/>
                                <input type="checkbox" checked={this.state.advanced} id="advanced" name="advanced" onChange={this.handleChange}/>
                            </div>
                            {this.state.advanced &&
                                <>
                                    <div className="form-group">
                                        <label htmlFor="globalPrizeWonHeader">Global Prize Won Header:</label>
                                        <input id="globalPrizeWonHeader" name="globalPrizeWonHeader" type="text" className="form-control" value={this.state.tenantVariables.globalPrizeWonHeader} onChange={this.handleChange} placeholder="You Win!"/>
                                    </div>
                                    <div className="form-group">
                                        <label htmlFor="globalPrizeWonBody">Global Prize Body:</label>
                                        <RichTextMarkdown
                                            field={{
                                                id: "globalPrizeWonBody",
                                                name: "globalPrizeWonBody",
                                                value: tenantVariables.globalPrizeWonBody || ""
                                            }}
                                            form={{
                                                setFieldValue: (field, value) => this.handleRichTextChange('globalPrizeWonBody', value)
                                            }}
                                            placeholder="Check your inbox for your prize!"
                                        />
                                    </div>
                                    <div className="form-group">
                                        <label htmlFor="globalNoPrizeHeader">Global No Prize Header:</label>
                                        <input id="globalNoPrizeHeader" name="globalNoPrizeHeader" type="text" className="form-control" value={this.state.tenantVariables.globalNoPrizeHeader} onChange={this.handleChange} placeholder="Nice Job!"/>
                                    </div>
                                    <div className="form-group">
                                        <label htmlFor="globalNoPrizeBody">Global No Prize Body:</label>
                                        <RichTextMarkdown
                                            field={{
                                                id: "globalNoPrizeBody",
                                                name: "globalNoPrizeBody",
                                                value: tenantVariables.globalNoPrizeBody || ""
                                            }}
                                            form={{
                                                setFieldValue: (field, value) => this.handleRichTextChange('globalNoPrizeBody', value)
                                            }}
                                            placeholder="Unfortunately you didn't win a prize!"
                                        />
                                    </div>
                                    <div className="form-group">
                                        <label htmlFor="globalNoneCorrectPrizeHeader">Global None Correct Prize Header:</label>
                                        <input id="globalNoneCorrectPrizeHeader" name="globalNoneCorrectPrizeHeader" type="text" className="form-control" value={this.state.tenantVariables.globalNoneCorrectPrizeHeader} onChange={this.handleChange} placeholder="Nice Job!"/>
                                    </div>
                                    <div className="form-group">
                                        <label htmlFor="globalNoneCorrectPrizeBody">Global None Correct Prize Body:</label>
                                        <RichTextMarkdown
                                            field={{
                                                id: "globalNoneCorrectPrizeBody",
                                                name: "globalNoneCorrectPrizeBody",
                                                value: tenantVariables.globalNoneCorrectPrizeBody || ""
                                            }}
                                            form={{
                                                setFieldValue: (field, value) => this.handleRichTextChange('globalNoneCorrectPrizeBody', value)
                                            }}
                                            placeholder="Unfortunately you didn't win a prize!"
                                        />
                                    </div>
                                </>
                            }
                          </div>
                          <div style={{display: this.state.gameTextTab === 'login' ? 'block' : 'none'}}>
                            <div className="form-group">
                                <label htmlFor="loginFormHeader">Login Form Header</label>
                                <RichTextMarkdown
                                    field={{
                                        id: "loginFormHeader",
                                        name: "loginFormHeader",
                                        value: tenantVariables.loginFormHeader || ""
                                    }}
                                    form={{
                                        setFieldValue: (field, value) => this.handleRichTextChange('loginFormHeader', value)
                                    }}
                                    placeholder=""
                                />
                            </div>
                            <div className="form-group">
                                <label htmlFor="aboveFormText">Above Form Text</label>
                                <RichTextMarkdown
                                    field={{
                                        id: "aboveFormText",
                                        name: "aboveFormText",
                                        value: tenantVariables.aboveFormText || ""
                                    }}
                                    form={{
                                        setFieldValue: (field, value) => this.handleRichTextChange('aboveFormText', value)
                                    }}
                                    placeholder="Enter text above the form"
                                />
                            </div>
                            <div className="form-group">
                                <label htmlFor="aboveSubmitButtonText">Above Submit Button Text</label>
                                <RichTextMarkdown
                                    field={{
                                        id: "aboveSubmitButtonText",
                                        name: "aboveSubmitButtonText",
                                        value: tenantVariables.aboveSubmitButtonText || ""
                                    }}
                                    form={{
                                        setFieldValue: (field, value) => this.handleRichTextChange('aboveSubmitButtonText', value)
                                    }}
                                    placeholder="Enter text above the submit button"
                                />
                            </div>
                            <div className="form-group">
                                <label htmlFor="belowSubmitButtonText">Below Submit Button Text</label>
                                <RichTextMarkdown
                                    field={{
                                        id: "belowSubmitButtonText",
                                        name: "belowSubmitButtonText",
                                        value: tenantVariables.belowSubmitButtonText || ""
                                    }}
                                    form={{
                                        setFieldValue: (field, value) => this.handleRichTextChange('belowSubmitButtonText', value)
                                    }}
                                    placeholder="Enter text below the submit button"
                                />
                            </div>
                          </div>
                        </div>
                    </form>
                  </div>
                </div>
            </div>
         </div>
        );
    }
}

export default SetUpTeamVariables;
